module.exports = __webpack_public_path__ + "media/icons/c-dark-9920f0df.svg";